import request from '../../utils/request'
//获取雜誌列表
export function getMagazineList(query) {
  return request({
    url: '/Magazine/list',
    method: 'post',
    data: query
  })
}
//获取雜誌详情
export function getMagazineDetails(id) {
  return request({
    url: `/Magazine/${id}`,
    method: 'get',
  })
}
//單本雜誌提交订单
export function createOrder(id) {
  return request({
    url: `/paypal/createOrder/${id}`,
    method: 'post',
  })
}
//添加到购物车
export function addCart(id) {
  return request({
    url: `/goods/add?goodsId=${id}`,
    method: 'get',
  })
}
//我的购物车
export function getCart() {
  return request({
    url: `/goods/cart`,
    method: 'get',
  })
}
//从购物车删除
export function delCart(id) {
  return request({
    url: `/goods/delCart?cartId=${id}`,
    method: 'get',
  })
}
//查询当前商品是否已加入购物车
export function checkInCart(id) {
  return request({
    url: `/goods/cart/${id}`,
    method: 'get',
  })
}
//查询当前商品是否已购买过
export function checkInOrder(id) {
  return request({
    url: `/goods/buy/${id}`,
    method: 'get',
  })
}
//购物车提交订单
export function createCartOrder() {
  return request({
    url: `/paypal/createOrderByCart`,
    method: 'post',
  })
}
//订单明细
export function orderDetails(orderNo) {
  return request({
    url: `/user/orderItem?orderNo=${orderNo}`,
    method: 'get',
  })
}



// 国内支付
export function createMagazineOrder(data) {
  return request({
    url: `/easypay/createMagazineOrder`,
    method: 'post',
    data
  })
}

export function createNewsOrder(data) {
  return request({
    url: `/easypay/createNewsOrder`,
    method: 'post',
    data
  })
}

// 查询支付状态
export function fetchOrderStatus(data) {
  return request({
    url: `/easypay/tradeQuery`,
    method: 'post',
    data
  })
}


// 搜索专家

export function searchExpert(data) {
  return request({
    url: `/easypay/tradeQuery`,
    method: 'post',
    data
  })
}
//保存进度
export function saveProgressFun(data) {
  return request({
    url: `/history/record`,
    method: 'post',
    data
  })
}
//获取进度
export function getProgressFun(data) {
  return request({
    url: `/history/query`,
    method: 'get',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/assets/api/magazine.js